import uaUtils from '../utils/uaUtils';
import log from './logger/log';
import storageService from './storageService';

const getSystemLanguage = () => {
    const language = navigator.language || navigator.userLanguage;

    return language.toUpperCase().split('-')[0];
};

const getIsPWA = () => {
    const isIosPWA = window.navigator.standalone === true;
    const isBrowserPWA = window.matchMedia('(display-mode: standalone)').matches;

    return isIosPWA || isBrowserPWA;
};

const getIsInstallPWASupported = () => {
    return 'onbeforeinstallprompt' in window && window?.deferredPrompt;
};

const getIsBrowserCompatible = () => {
    if (storageService.getIsBrowserCheckDisabled()) {
        return true;
    }

    if (import.meta.env.DEV) {
        return true;
    }

    if (uaUtils.getIsMobile()) {
        return uaUtils.getIsChrome() || uaUtils.getIsSafari();
    }

    // Desktop
    return false;
};

// Get the real OS version, since navigator.userAgent may be unreliable (e.g., Android always shows 10)
// Chrome docs - https://www.chromium.org/updates/ua-reduction/
let highEntropyOSVersion = null;

const getHighEntropyOSVersion = () => highEntropyOSVersion;

const updateHighEntropyOSVersion = async () => {
    if (navigator?.userAgentData) {
        try {
            const data = await navigator.userAgentData.getHighEntropyValues(['platformVersion']);

            highEntropyOSVersion = data?.platformVersion;
            log.debug(`userBrowserService: High entropy OS version updated: ${highEntropyOSVersion}`);
        } catch (e) {
            log.warn('userBrowserService: Failed to get high entropy OS version:', e?.message);
        }
    } else {
        log.warn('userBrowserService: User-agent client hints not supported');
    }
};

export const userBrowserService = {
    getIsPWA,
    getSystemLanguage,
    getIsInstallPWASupported,
    getIsBrowserCompatible,
    updateHighEntropyOSVersion,
    getHighEntropyOSVersion,
};
